import React, {useState, useRef} from 'react'
import Sidebar from "../../components/sidebar/Sidebar";
import "../../styles/sidebar/sidebar.css";
import Header from "../../components/header/Header";
import RecordedDataComponent from '../../components/recordedData/RecordedDataComponent';

const SupervisorScannedRecordedData = () => {
  return (
        <>
        <div className="recorded-data-container">
                <Sidebar role="supervisor"/>
            <div className="main-content">
                <Header/>
                <RecordedDataComponent role="coordinator" title="RECORDED SCANNED DATA"/>
            </div>
        </div>
        </>
      )
}

export default SupervisorScannedRecordedData